import { Typography, Box } from "@avenue-8/sidekick-ui";
import { KeyFeaturesSectionView } from "@cma/presentation-generation-logic";
import styled from "@emotion/styled";
import { KeyFeatureItem } from "./components/KeyFeatureItem";
import { useKeyFeaturesLogic } from "./useKeyFeaturesLogic";
import { KeyFeaturesWrapperPrint } from "./KeyFeatures.styles";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { PrintPaper, PrintPage } from "../../shared/Print.styles";

type Props = PresentationSectionViewProps<KeyFeaturesSectionView>;

const PrintKeyFeaturesGrid = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  row-gap: 4rem;
  padding: 0;
  width: 100%;

  > * {
    width: calc(25% - 1rem);
    transform: scale(1.3);
    transform-origin: top center;
  }

  @media print {
    row-gap: 4rem;
  }
`;

export const KeyFeaturesPrint = (props: Props) => {
  const { sectionView } = props;
  const { keyFeaturesOptions } = useKeyFeaturesLogic({ sectionView });

  return (
    <>
      <PrintPaper>
        <PrintPage>
          <Typography variant="h5" mb={2} textAlign={"center"}>
            {sectionView.title}
          </Typography>

          <KeyFeaturesWrapperPrint>
            <PrintKeyFeaturesGrid>
              {keyFeaturesOptions.map((feature) => {
                if (!feature.show) return null;
                return (
                  <KeyFeatureItem
                    key={feature.configName}
                    configName={feature.configName}
                    valueName={feature.valueName}
                    title={feature.title}
                    value={feature.value}
                  />
                );
              })}
            </PrintKeyFeaturesGrid>
          </KeyFeaturesWrapperPrint>
        </PrintPage>
      </PrintPaper>
    </>
  );
};
